<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
export default {
  name: 'AttachmentItem',
  props: {
    attachment: Object,
    fallbackImageText: {
      type: String,
      default: '',
    },
    height: Number,
  },
  computed: {
    imageHeight() {
      return this.exceptionalCustomers() ? this.height || '100%' : 'auto'
    },
  },
  methods: {
    isImage(attachment) {
      return attachment.type.indexOf('image') > -1
    },
  },
}
</script>
